import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
// react component used to create charts

import Card from "../../components/Card/Card.jsx";
import logo from "../../assets/img/logo_white_transparent.png";
import image from "../../assets/img/full-screen-image-3.jpg";

class Home extends Component {
  render() {
      //Notice below that we are checking the window size to be sure that the width is big enough to render the logo if not we
      //render just text so it will look good on iPhones.
    return (
        <div className="main-content" style={{backgroundImage: "url("+require("../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
          backgroundPosition: "center center"}}>
        {/*<div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/" + "matrix.jpg") + ")" }}>
            {/*<div className="main-content">*/}
        <Grid fluid>
          <Row>
            <Col md={10} xs={10} xsOffset={1}>
                {
                    window.innerWidth > 460 ? (
                      <Card
                        title="Welcome to "
                        category=""
                        content={
                            <div className="logo">
                                    <div className="logo-img">
                                        <img src={logo} alt="tro-logo"/>
                                    </div>
                            </div>
                        }
                      />
                    ) : (
                        <Card
                            title="Welcome to "
                            category=""
                            content={
                                <div className="typo-line">
                                    <p>TRO - Tattoo Release Online</p>
                                    <p>Designed by shop owners, for shop owners.<br></br> The only user friendly and fully
                                        customizable tattoo and piercing consent forms online.</p>
                                </div>
                    }
                    />)
                }
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Home.jsx